import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.css';
import Moment from 'moment';
import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { BsInfoSquare } from 'react-icons/bs';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { toast } from 'react-toastify';
import environment from './environments/environment';
import Pagination from './Pagination';
import PagerService from './Services/PagerService';

const mapStateToProps = (state) => {
    return {
        userStatus: state.lognReducer
    }
}

class CaseUpdateHistory extends React.Component {
    constructor() {
        super();
        this.state = {
            caseList: [],
            pageSize: '',
            totalItems: '',
            //pager object
            pager: {},
            // paged items
            pagedItems: [],
            //searchFlag: false,
            caseListCount: '',
            email: '',
            userRole: '',
            caseUHList: []
        }
    }

    componentDidMount = async () => {
        if (this.props.userStatus.userName !== "") {
            this.setState({
                pageSize: this.toSetPagination(),
                email: this.props.userStatus.emailId,
                userRole: this.props.userStatus.userRole
            }, () => {
                this.setPage(1);
            })
        } else {
            this.setState({
                reDirect: '/',
            })
        }
    }

    toSetPagination() {
        let pageSize = 0;
        if (localStorage.getItem("listingPageSize") != null &&
            localStorage.getItem("listingPageSize") !== undefined && localStorage.getItem("listingPageSize") !== '0') {
            let tempstr = localStorage.getItem("listingPageSize");
            pageSize = parseInt(tempstr);
        }
        else {
            pageSize = 5;
        }
        return pageSize;
    }

    onPageNoChanged = (pageNo) => {
        this.setPage(pageNo);
    }

    pageSizeChanged = (pageSize) => {
        this.setState({
            pageSize: pageSize
        }, () => {
            this.setPage(1);
            localStorage.setItem('listingPageSize', pageSize);
        })
    }

    setPage(page) {
        this.togetCaseUpdateHistory(page, this.state.pageSize);
    }
    togetCaseUpdateHistory(page, pageSize) {
        axios.get(environment.getCaseUpdateHistory + this.props.caseId + "?userName=" + this.state.email).then(response => {

            if (response.data.caseUpdatedHistoryVOList !== undefined && response.data.caseUpdatedHistoryVOList !== null && response.data.caseUpdatedHistoryVOList.length > 0) {

                this.setState({
                    caseUHList: response.data.caseUpdatedHistoryVOList,

                    caseUHCount: response.data.caseUpdatedHistoryVOList.length
                }, () => {
                    if (this.state.caseUHCount !== 0) {
                        this.setState({
                            pageSize: this.toSetPagination(),
                            pager: PagerService.getPager(
                                this.state.caseUHCount,
                                page,
                                this.state.pageSize
                            ),
                            totalItems: this.state.caseUHCount,
                            pagedItems: this.state.caseUHList.slice(
                                (page - 1) * this.state.pageSize,
                                page * this.state.pageSize
                            )
                        });
                    } else {
                        this.setState({
                            totalItems: 0,
                            caseUHList: null,
                            pagedItems: null
                        })
                    }
                })

            } else {
                this.setState({
                    totalItems: 0
                })
            }
        }).catch((error) => {
            toast.error(error.message, { position: toast.POSITION.TOP_CENTER });
        });
    }

    render() {
        if (this.state.reDirect) {
            return <Redirect
                to={{
                    pathname: this.state.reDirect, state: {
                        caseId: this.state.caseId,

                    }
                }} />
        }
        return (
            <section>
                <h6>Case Update History&nbsp;<OverlayTrigger placement="top" overlay={<Tooltip id={'tst'}>Provides case fields update history. Fields includes - Case Name, Report Start Date, Report Interval, Supervisor, Attorney.</Tooltip>}><span><BsInfoSquare></BsInfoSquare></span></OverlayTrigger></h6>
                <div className="table-responsive dashboard ">
                    <table className="table table-bordered table-condensed table-striped table-hover table-sm"
                        id="table-dashboard1">
                        <thead className="color" style={{ borderStyle: 'hidden' }}>
                            <tr>
                                <th style={{ width: '20%' }}>Modified Timestamp</th>
                                <th >Modified Field Name</th>
                                <th >Previous Value</th>
                                <th >New Value</th>
                                <th style={{ width: '20%' }}>Modified By</th>
                            </tr>
                        </thead>
                        <tbody style={{ borderStyle: 'hidden' }}>
                            {this.state.pagedItems.map((caseUHList, index) => (
                                <tr key={index}>
                                    <td >{Moment(caseUHList.changedDate).format('MM/DD/YYYY hh:mm:ss A')}</td>
                                    {caseUHList.fieldName === 'attorney' && <td  > Attorney</td>}
                                    {caseUHList.fieldName === 'supervisor' && <td  >Supervisor</td>}
                                    {caseUHList.fieldName === 'reportInterval' && <td  >Report Interval</td>}
                                    {caseUHList.fieldName === 'dueDate' && <td  >Due Date</td>}
                                    {caseUHList.fieldName === 'isActive' && <td  >Is Active</td>}
                                    {caseUHList.fieldName === 'caseName' && <td  >Case Name</td>}
                                    {caseUHList.fieldName === 'reportStartDate' && <td  >Report Start Date</td>}
                                    <td style={{ wordBreak: 'break-all' }}>{(caseUHList.fieldName === 'attorney' || caseUHList.fieldName === 'supervisor') ? caseUHList.fromName : caseUHList.fieldName === 'reportStartDate' ? Moment(caseUHList.fieldFrom).format('MM/DD/YYYY') : caseUHList.fieldFrom}</td>
                                    <td style={{ wordBreak: 'break-all' }}>{(caseUHList.fieldName === 'attorney' || caseUHList.fieldName === 'supervisor') ? caseUHList.toName : caseUHList.fieldName === 'reportStartDate' ? Moment(caseUHList.fieldTo).format('MM/DD/YYYY') : caseUHList.fieldTo}</td>
                                    <td>{caseUHList.changedBy}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {this.state.totalItems === 0 && <p> No Records are Found.</p>}
                {this.state.pagedItems !== undefined && this.state.totalItems > 5 &&
                    <Pagination pager={this.state.pager} setPage={this.onPageNoChanged} setPageSize={this.pageSizeChanged}></Pagination>}
            </section >
        )
    }

}
export default connect(mapStateToProps)(CaseUpdateHistory);